var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.to ? 'router-link' : _vm.href ? 'a' : 'button',_vm._b({ref:_vm.$refs,tag:"component",staticClass:"base-button",class:{
    '__full-width': _vm.fullWidth,
    '__secondary': _vm.secondary,
    '__gradient': _vm.gradient,
    '__outline': _vm.outline,
    '__outline-secondary': _vm.outlineSecondary,
    '__outline-gray': _vm.outlineGray,
    '__gray': _vm.gray,
    '__green': _vm.green,
    '__red': _vm.red,
    '__white': _vm.white,
    '__small': _vm.small,
    '__x-small': _vm.xSmall,
    '__medium': _vm.medium,
    '__round': _vm.round,
    '__disabled': _vm.disabled,
    '__transparent': _vm.transparent,
    '__text-like': _vm.textLike,
    '__link-like': _vm.linkLike,
  },attrs:{"disabled":_vm.disabled,"target":(_vm.to || _vm.href) && _vm.target},on:{"click":_vm.onClick}},'component',_vm.$props,false),[(!_vm.loading)?_vm._t("default"):_c('base-spinner',{attrs:{"size":_vm.spinnerSize,"color":_vm.spinnerColor ? _vm.spinnerColor : _vm.secondary || _vm.outline ? 'var(--palette-negative)' : _vm.gray ? '' : 'var(--palette-bg)'}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }